import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Boleto } from '../models/Boleto';
import { Router } from '@angular/router';
import { LocalstorageService } from '../services/localstorage.service';
import { timer } from 'rxjs';
import { MyHttpGetService } from '../services/http.services.token';
import { environment } from '../../environments/environment';

@Injectable()
export class TimerService {

	minutesDisplay: number = 0;
	secondsDisplay: number = 0;
	ms: number = 0;

	sub: Subscription;
	public boletos_bloqueados: { boletos: Array<Object>, fecha: string, orden : string, carrito } = { boletos: [], fecha: "", orden : "", carrito : "" };
  public boletos_bloqueados_local: Array<Boleto> = [];
  private folio : string;

  public showWarningModal: boolean = false;
  public modalCountdown: number = 0;
  public pagoEnProceso: boolean = false;
  // Flujos de tarjeta in-page (Stripe): el contador sigue VISIBLE y, si se agota el tiempo,
  // se libera el boleto AUNQUE ya exista folio (orden PP no pagada). Referencia/OXXO/SPEI no lo usan.
  public liberarConFolio: boolean = false;
  private warningShown: boolean = false;
  private modalSub: Subscription;

	constructor(private _local: LocalstorageService, private router: Router, private myGetService: MyHttpGetService) {}

	public startTimer() {
		if (this.sub) this.sub.unsubscribe();
		if (this.modalSub) this.modalSub.unsubscribe();
		this.warningShown = false;
		this.showWarningModal = false;
		this.pagoEnProceso = false; // nueva sesión de carrito: no hay pago en curso
		this.liberarConFolio = false;
		const baseTimer = timer(1, 1000);
		this.sub = baseTimer.subscribe(t => {
			var currentDate = new Date();
			var fechaFin = new Date(this._local.getFechaFin());

			this.ms = fechaFin.getTime() - currentDate.getTime();

			var minutes = Math.floor(this.ms / 60000);
			var seconds = ((this.ms % 60000) / 1000).toFixed(0);
			this.minutesDisplay = minutes;
			this.secondsDisplay = parseInt(seconds);

			// Mostrar modal de advertencia cuando queden menos de warningMinutos (y no esté ya mostrado)
			if (
        environment.warningMinutos > 0 &&
        !this.warningShown &&
        !this.pagoEnProceso &&
        this.minutesDisplay >= 0 &&
        this.minutesDisplay < environment.warningMinutos &&
        !(this.minutesDisplay <= 0 && this.secondsDisplay <= 0)
      ) {
        this.warningShown = true;
        this.showWarningModal = true;
        this.iniciarCountdownModal();
      }

			if (this.minutesDisplay <= 0 && this.secondsDisplay <= 0) {
        this.folio = this._local.getFolio();
        // No liberar si hay un pago en curso. Con folio generado NO se libera, EXCEPTO en flujos
        // de tarjeta in-page (liberarConFolio=true, ej. Stripe): ahí sí se libera al agotarse el tiempo.
        if (!this.pagoEnProceso && (!this.folio || this.liberarConFolio)) {
          this.expirarSesion();
        } else {
          var date = new Date();
          this._local.setFechaFin(date);
          this.sub.unsubscribe();
          this.sub.closed;
        }
			}
		});
	}

  private iniciarCountdownModal(): void {
    this.modalCountdown = environment.warningCountdownSegundos;
    const modalTimer = timer(1000, 1000);
    this.modalSub = modalTimer.subscribe(() => {
      this.modalCountdown--;
      if (this.modalCountdown <= 0) {
        if (this.modalSub) this.modalSub.unsubscribe();
        this.liberarPorModal();
      }
    });
  }

  public iniciarPago(minutos: number): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    this.showWarningModal = false;
    this.pagoEnProceso = true;
    this._local.setFechaFin(new Date(), minutos);
  }

  public finalizarPago(): void {
    this.pagoEnProceso = false;
  }

  /**
   * Extiende la reserva N minutos MANTENIENDO el contador visible (no marca pagoEnProceso) y
   * permitiendo liberar el boleto si el tiempo se agota aunque exista folio. Para tarjeta in-page (Stripe).
   */
  public extenderVisible(minutos: number): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    this.showWarningModal = false;
    this.warningShown = false;
    this.pagoEnProceso = false;
    this.liberarConFolio = true;
    this._local.setFechaFin(new Date(), minutos);
  }

  /**
   * Detiene el timer por completo, sin liberar boletos ni navegar a ningún lado.
   * Se usa cuando la pantalla ya decidió cortar el flujo por su cuenta y va a mostrar
   * su propio aviso (ej. el modal de bloqueo del carrito). Sin esto, al borrarse el
   * storage el timer se queda sin fechaFin, cree que expiró y navega al home al
   * siguiente segundo, cerrando el aviso antes de que alcance a leerse.
   */
  public detener(): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
    this.showWarningModal = false;
    this.warningShown = true;
    this.pagoEnProceso = true;
    this.minutesDisplay = 0;
    this.secondsDisplay = 0;
  }

  /** Detiene el timer y el modal "¿Sigues ahí?" para el flujo OXXO (pago asíncrono). */
  public detenerPorOxxo(): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
    this.showWarningModal = false;
    this.warningShown = true;
    this.pagoEnProceso = true;
    this.minutesDisplay = 0;
    this.secondsDisplay = 0;
  }

  public resetModal(): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    this.showWarningModal = false;
  }

  public continuarSesion(): void {
    if (this.modalSub) this.modalSub.unsubscribe();
    this.showWarningModal = false;
    this.warningShown = false;

    const carritoId = this._local.getCarrito();
    if (carritoId) {
      this.myGetService.postData({ carrito: carritoId }, 'api/BoletosWeb/RenuevaSesion').subscribe(
        () => {},
        () => {}
      );
    }
    this._local.setFechaFin(new Date(), environment.renovaMinutos);
  }

  private liberarPorModal(): void {
    this.showWarningModal = false;
    // Candado anti-carrera: si mientras corría el countdown del modal se generó un folio
    // o se inició un pago, NO liberar los boletos (ya hay una orden/referencia viva).
    if (this.pagoEnProceso || (this._local.getFolio() && !this.liberarConFolio)) {
      return;
    }
    this.expirarSesion();
  }

  private expirarSesion(): void {
    this.LiberaBoletos();
    this._local.deleteBoletosGenerados();
    this._local.deleteBoletosRecomendados();
    this._local.deleteBoletosApartados();
    this._local.deleteFechaFin();
    this._local.deleteFechaInicio();
    this._local.deleteBoletosBloqueados();
    this._local.deleteCarrito();
    this.minutesDisplay = 0;
    this.secondsDisplay = 0;
    if (this.modalSub) this.modalSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
    this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
  }

  private LiberaBoletos(): void {
    var lsApartados = this._local.getBoletosApartados();
    var lsCarrito = this._local.getCarrito();
    var lsBloqueados = this._local.getBoletosBloqueados();
    this.boletos_bloqueados.boletos = lsApartados == null ? [] : JSON.parse(lsApartados);
    this.boletos_bloqueados_local = lsBloqueados == null ? [] : JSON.parse(lsBloqueados);
    this.boletos_bloqueados.orden = this._local.getFolio();
    this.boletos_bloqueados.carrito = lsCarrito;
    this.boletos_bloqueados.boletos = [...this.boletos_bloqueados.boletos, ...this.boletos_bloqueados_local];
    if (this.boletos_bloqueados.carrito && this.boletos_bloqueados.boletos.length != 0) {
      this.boletos_bloqueados.fecha = new Date().toISOString();
      this.myGetService.postData(this.boletos_bloqueados, 'api/BoletosWeb/LiberaBoletos').subscribe((res) => {});
    }
  }
}
